export const DATA_TIERING_LICENSE_TITLE = 'Warm Tier is disabled';
export const DATA_TIERING_LICENSE_TEXT =
  'Warm Tier is disabled because there is no valid license. Note that any data previously stored within the Warm Tier will remain searchable.';
export const DATA_TIERING_UPSELL_TITLE = 'Upgrade to access Data Tiering';
export const DATA_TIERING_UPSELL_TEXT =
  'Do more with your data! Gain Warm Tiers, Archiving, and other data management features for more flexible storage options with less administration.';
